var map = {
	"./about_add_to_cart.png": 21517,
	"./about_add_to_cart_modal.png": 43303,
	"./about_cart_summary.png": 24333,
	"./alliance_logo.svg": 41782,
	"./app_store_apple.webp": 63122,
	"./app_store_google.webp": 70997,
	"./book_print.png": 3480,
	"./cds_logo.svg": 91677,
	"./diamond_collection.jpg": 5664,
	"./diamond_collection.png": 35886,
	"./diamond_complete.jpg": 75828,
	"./diamond_complete.png": 65316,
	"./diamond_single.jpg": 93334,
	"./diamond_single.png": 23083,
	"./diamond_staff.jpg": 42846,
	"./doc_search.png": 3360,
	"./errata.jpg": 40447,
	"./es.jpg": 94315,
	"./es_logo.svg": 44067,
	"./facebook.png": 71485,
	"./flickr.png": 59579,
	"./flickr.svg": 61346,
	"./gc_logo.svg": 3882,
	"./ias_logo.svg": 70983,
	"./icc.png": 90054,
	"./icc_logo.svg": 89018,
	"./linkdin.png": 28360,
	"./logo.png": 67136,
	"./menu_cdp.png": 69944,
	"./menu_home.png": 3748,
	"./menu_my_icc.png": 97193,
	"./menu_online_codes.png": 68906,
	"./menu_store.png": 41675,
	"./menu_support.png": 11139,
	"./nta_logo.svg": 98504,
	"./package_collection.png": 38712,
	"./package_complete.png": 50157,
	"./package_single.png": 44405,
	"./pdf_book_cover.png": 54400,
	"./pdf_download.png": 26340,
	"./pdficon.png": 65629,
	"./premium-only.png": 76146,
	"./premium_answers_icon.svg": 87654,
	"./premium_content.png": 15933,
	"./purchased_product.png": 20621,
	"./see_inside_book_cover.png": 85781,
	"./skga_logo.svg": 48387,
	"./srcc.png": 85065,
	"./tablet.png": 58940,
	"./titles/RGB_IBC.svg": 63024,
	"./titles/RGB_ICCPC.svg": 99334,
	"./titles/RGB_IEBC.svg": 75358,
	"./titles/RGB_IECC.svg": 40849,
	"./titles/RGB_IFC.svg": 97990,
	"./titles/RGB_IFGC.svg": 82089,
	"./titles/RGB_IMC.svg": 41812,
	"./titles/RGB_IPC.svg": 67397,
	"./titles/RGB_IPMC.svg": 44165,
	"./titles/RGB_IPSDC.svg": 59589,
	"./titles/RGB_IRC.svg": 63662,
	"./titles/RGB_ISPSC.svg": 29731,
	"./titles/RGB_IWUIC.svg": 29665,
	"./titles/RGB_IZC.svg": 35273,
	"./titles/RGB_IgCC.svg": 14532,
	"./twitter.png": 99274,
	"./video_tag.png": 14198,
	"./youtube.png": 24464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98432;